import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  container: FelaCSS;
  contentWrap: FelaCSS;
  searchBarIcon(loading: boolean): FelaCSS;
}

const styles = (): IStyles => ({
  container: {
    paddingBottom: 6,
    paddingLeft: 0,

    maxWidthTabletSm: {
      paddingLeft: '0',
      paddingRight: '0',
      paddingBottom: '0',

      minWidthTablet: {
        width: '100%',
      },
    },
  },

  contentWrap: {
    flexGrow: 1,
    lineHeight: '1.6em',
  },
  searchBarIcon: (loading) => ({
    backgroundColor: loading ? colors.space40 : colors.indigoCrush,
    borderRadius: '100%',
    minWidth: 32,
    height: 32,
    marginRight: 2,
  }),
});

export default styles;
